import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const BookletMaterialDeleteSlice = createSlice({
  name: "BookletMaterialDeleteSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    bookletMaterialDelete: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successBookletMaterialDelete: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureBookletMaterialDelete: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearBookletMaterialDelete: (state) => {
      state.data = {};
    },
  },
});

export const {
  bookletMaterialDelete,
  failureBookletMaterialDelete,
  successBookletMaterialDelete,
  clearBookletMaterialDelete,
} = BookletMaterialDeleteSlice.actions;

export default BookletMaterialDeleteSlice.reducer;
